import React from 'react';
import ReactDOM from 'react-dom/client';
import './reset.css';
import './common.scss';
import { App } from './App';

ReactDOM.createRoot(document.getElementById('root')).render(<App />);